// src/data/facebookActivitiesPosts.js

export const facebookActivitiesPosts = [
  {
    id: 1,
    href: "https://www.facebook.com/nl.chiangmai/posts/pfbid02sJMBZNHJ7H5VAACBBXndYkVBKix6DxKpfAvytQVJCYYZ6oDyA57LwzTS8JwEVBCZl",
    isFeatured: false,
  },
  {
    id: 2,
    href: "https://www.facebook.com/nl.chiangmai/posts/pfbid02h9vZaA8WDRByMPyEpaE3Adq9D9t7h37zSLkbaVPTuaLnA6eHZqNDeccwMBj9sn9El",
    isFeatured: false,
  },
  {
    id: 3,
    href: "https://www.facebook.com/nl.chiangmai/posts/pfbid0hY7BuxERnEbScj1Ht1LEuG9CbW2jQTG6q18SS3eQrMmFwdZYAqjnYLj79r2rzBAl",
    isFeatured: false,
  },
  {
    id: 4,
    href: "https://www.facebook.com/nl.chiangmai/posts/pfbid027skBKSar3uMEPUM4ZVTmiQqfsdJktHxwG929s2dVrfYdRDc4ksxaNBoaaYaBCj4Cl",
    isFeatured: false,
  },
  {
    id: 5,
    href: "https://www.facebook.com/nl.chiangmai/posts/pfbid02Fy5zEXBvYcmvVX2kxwqomTrjJPjR4Ez7wv2f2BaP9T2WTvhno254vyiSA6vPodt6l",
    isFeatured: false,
  },
];

export function buildFacebookPostHtml(href) {
  return `
    <div class="fb-post"
      data-href="${href}"
      data-width="auto"
      data-show-text="true"></div>
  `;
}